<template>
  <div>
    <div :class="[style.block, style.requiredBottom]">
      <div :class="style.switchBlock">
        <span :class="style.heading">Ввод в несколько строк</span>

        <SwitchComponent
          :modelValue="isTextAreaType"
          @update:modelValue="setTypeTextArea"
          @change="setTypeTextArea"
        />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import {defineComponent, PropType} from "vue";
import style from "../../QuestionPanelComponent.module.scss";
import SwitchComponent from "@/elements/UI/input/Switch/SwitchComponent.vue";
import {questions} from "@/page/quiz/typeQuiz";

export default defineComponent({
  name: "TextQuestionSetting",

  components: {
    SwitchComponent
  },

  props: {
    question: {
      type: Object as PropType<questions | null>,
      default: null
    }
  },

  data() {
    return {
      style
    };
  },

  computed: {
    isTextAreaType(): boolean {
      return this.question?.type === "textArea";
    }
  },

  methods: {
    setTypeTextArea(value: boolean | Event): void {
      if (!this.question) {
        return;
      }

      const isTextArea = this.getSwitchValue(value);

      this.question.type = isTextArea ? "textArea" : "text";
    },

    getSwitchValue(value: boolean | Event): boolean {
      if (value instanceof Event) {
        return Boolean((value.target as HTMLInputElement | null)?.checked);
      }

      return Boolean(value);
    }
  }
});
</script>
